import { IS_MOBILE_WIDTH } from 'hooks/useMobileDetector';
import {
  AccessEventFiltersState,
  AuthState,
  CardsState,
  CurrentTenantState,
  DoorsState,
  DoorsWithLocationsStateComplete,
  ExternalUsersGroupsState,
  GraphqlTokenState,
  LocationsWithDoorsState,
  MfaPreferenceState,
  PermissionsState,
  RequestState,
  RestApiKeysState,
  SchedulesState,
  TenantLegalDocumentsState,
  TenantRegistrationState,
  TenantsServiceTokenState,
  UiState,
  VisitorGroupsWithIsOfficeModeEnabledState,
  VisitorsGroupsMembersState,
  VisitorsGroupsState,
  VisitorsGroupsWithAccessGrantsState
} from './types';

export const doorsInitialState: DoorsState = [];
export const doorsWithLocationsInitialState: DoorsWithLocationsStateComplete = [];

export const authInitialState: AuthState = {
  loading: true,
  user: null,
  cognitoUser: null
};

export const graphqlTokenInitialState: GraphqlTokenState = {
  loading: true,
  tokenType: 'NONE',
  isTriggerFetchToken: true
};

export const locationsWithDoorsInitialState: LocationsWithDoorsState = [];

// @ts-ignore
export const uiInitialState: UiState = {
  drawerState: null,
  isMobile: window.innerWidth < IS_MOBILE_WIDTH,
  isMobileLandscape: window.innerWidth > window.innerHeight
};

export const visitorsGroupsInitialState: VisitorsGroupsState = [];
export const installersGroupsInitialState: VisitorsGroupsMembersState = [];
export const visitorsGroupsMembersInitialState: VisitorsGroupsMembersState = [];
export const visitorsGroupsWithAccessGrantsState: VisitorsGroupsWithAccessGrantsState = [];
export const externalUsersGroupsInitialState: ExternalUsersGroupsState = [];
export const schedulesInitialState: SchedulesState = [];

export const requestStateInitialState: RequestState = {
  inProgress: false
};

export const accessEventFiltersState: AccessEventFiltersState = { filters: {}, appliedFilters: {} };

export const permissionsInitialState: PermissionsState = [];
export const mfaPreferenceInitialState: MfaPreferenceState = null;
export const cardsInitialState: CardsState = [];

export const visitorGroupsWithIsOfficeModeEnabledInitialState: VisitorGroupsWithIsOfficeModeEnabledState = [];

export const tenantLegalDocumentsInitialState: TenantLegalDocumentsState = null;
export const tenantsServiceTokenInitialState: TenantsServiceTokenState = null;
export const tenantRegistrationInfoInitialState: TenantRegistrationState = null;

export const restApiKeysInitialState: RestApiKeysState = [];

export const currentTenantInitialState: CurrentTenantState = null;
